var Numeric = require('./Numeric'),
	CurrencySettings = require('./CurrencySettings');

/**
 * The Currency class represents a currency data type. It handles the
 * formatting and accepts several options like second property for
 * the unit of measurement or if the unit of measurement should be
 * displayed.
 *
 * It styles currencies with its particular amount of decimals.
 *
 * @param {Object} oConfig - A configuration object that is used to specify the formatting
 * @param {string} oConfig.unitProperty - A custom format string that will be used as template
 * @param {boolean} [oConfig.displayUnit] - Indicating whether the unit of measurement will be shown (default: true)
 * @param {number} [oConfig.scale] - A fixed scale that will be applied to all cells within this column,
 * regardless of its particular unit of measurement
 * @constructor
 */
function Currency(oConfig) {
	Numeric.call(this, oConfig);

	this.displayUnit = oConfig && typeof oConfig.displayUnit === 'boolean' ? oConfig.displayUnit : true;
}

Currency.prototype = Object.create(Numeric.prototype);
Currency.prototype.constructor = Currency;

/**
 * Returns the currency specific scale.
 *
 * @param {string} sCurrency - ISO currency code like USD for $ and EUR for € etc.
 * @returns {number} A number between 2 and 3 depending on the scale of the given currency
 * @public
 * @static
 */
Currency.getCurrencyScale = function(sCurrency) {
	var iScale;

	iScale = CurrencySettings.DIGITS[sCurrency];

	/* If the currency uses the default scale */
	if (typeof iScale !== 'number') {
		iScale = CurrencySettings.DIGITS.DEFAULT;
	}

	return iScale;
};

/**
 * Creates the Style configuration needed for registering the Type
 * specific styling in the Styles class.
 *
 * @param {Object} oData - Business object that gets bound to the styling template
 * @returns {Object} - Styling configuration object
 * @protected
 */
Currency.prototype._createConfiguration = function(oData) {
	var i, j, scale, template, unit;

	// TODO implement inheritance with Numeric class

	template = '#,##0';

	/* Apply fixed scale, only if no unitProperty is provided */
	if (!this.unitProperty && typeof this.scale === 'number') {
		scale = this.scale;
	} else {
		scale = Currency.getCurrencyScale(oData[this.unitProperty]);
	}

	/* Apply separator or placeholder */
	template += (scale > 0) ? '.' : '_.';

	for (i = 0; i < scale; i++) {
		template += '0';
	}

	for (j = CurrencySettings.DEFAULT_SCALE - scale; j > 0; j--) {
		template += '_0';
	}

	/* Add unit of measurement if required */
	if (this.displayUnit) {
		unit = oData[this.unitProperty] ? '"' + oData[this.unitProperty] + '"' : '_E_U_R';

		// Applies unit of measurement or a placeholder if unit is empty
		template = template + '\\ ' + unit;
	}

	// Add formatting for negative values as well
	template = '* ' + template + ';* \\-\\ ' + template;

	return { numberFormat: { format: template } };
};

module.exports = Currency;


//////////////////
// WEBPACK FOOTER
// ./core/xlsx/src/binding/type/Currency.js
// module id = 4
// module chunks = 0